import { Injectable } from '@angular/core';
import { DatabaseGwService } from '../database-gw.service';

@Injectable({
  providedIn: 'root'
})
export class TransferProdService extends DatabaseGwService{

  URL_PATH: string = "/transfer-prods";
}
